// Homework-completion (BTVN) scale shared across the Learning Results tab and the
// homework-% charts. 4-step evenly-weighted average: excellent=100 … none=0.
// '' (ungraded) is excluded from any average.

export const HOMEWORK_LEVELS = [
    { code: 'excellent',  label: 'Hoàn thành xuất sắc', weight: 100,   color: '#4CAF6E' },
    { code: 'complete',   label: 'Hoàn thành',          weight: 66.67, color: '#52B6CE' },
    { code: 'incomplete', label: 'Chưa đầy đủ',         weight: 33.33, color: '#E8A04C' },
    { code: 'none',       label: 'Chưa làm',            weight: 0,     color: '#D95C5C' },
];

const WEIGHT = Object.fromEntries(HOMEWORK_LEVELS.map(l => [l.code, l.weight]));
const LABEL  = Object.fromEntries(HOMEWORK_LEVELS.map(l => [l.code, l.label]));

// Numeric weight for a level code, or null if ungraded ('' / unknown) → caller skips it.
export function homeworkWeight(code) {
    return code in WEIGHT ? WEIGHT[code] : null;
}

export function homeworkLabel(code) {
    return LABEL[code] || '';
}

// Mean of the graded weights in a list of level codes (ignores ungraded). null if none graded.
export function homeworkAverage(codes) {
    const vals = codes.map(homeworkWeight).filter(v => v !== null);
    if (!vals.length) return null;
    return vals.reduce((a, b) => a + b, 0) / vals.length;
}
